/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const AboutCsap = () => (
  <Layout>
    <div className='aboutCsap'>
      <h1 className='CsapTitle'>Yaaro Child Sexual Abuse Policy</h1>

      <h2>Zero Tolerance Statement</h2>
      <p>
        Yaaro enforces a strict zero-tolerance policy against any content related to child sexual abuse or any material that may harm minors. Users are absolutely forbidden from using Yaaro's services to create, publish, reproduce, transmit, distribute, or store such content. Prohibited conduct and materials include, but are not limited to, the following:
      </p>
      <ul>
        <li>
          <strong>Sexualisation of Minors:</strong> Any sexually explicit content involving minors, or any content that sexually exploits minors in any manner.
        </li>
        <li>
          <strong>Sexual Acts Involving Minors:</strong> Content depicting minors engaging in sexual activities or encouraging minors to participate in such acts.
        </li>
        <li>
          <strong>Misleading or Age-Inappropriate Content:</strong> Any material targeting young minors that contains:
          <ul>
            <li>Sexual or sexually explicit themes.</li>
            <li>Sexual violence.</li>
            <li>Obscene subjects.</li>
            <li>Other adult or age-inappropriate themes, such as graphic violence or sexual content.</li>
          </ul>
        </li>
      </ul>

      <h2>Immediate Enforcement Actions</h2>
      <p>
        If Yaaro becomes aware that its services have been used to store and/or transmit such prohibited content, we will act immediately and take the following steps:
      </p>
      <ul>
        <li>Remove any and all offending content.</li>
        <li>Block the user accounts involved in the violation.</li>
        <li>Report all related activities to the relevant law enforcement or regulatory authorities.</li>
      </ul>
      <p>
        Yaaro also reserves the right to take further actions, including fully cooperating with law enforcement agencies or government bodies to assist in the investigation and prosecution of individuals responsible for such offenses.
      </p>

      <h2>Reporting Child Sexual Abuse Content</h2>
      <p>
        If you become aware of any child sexual abuse, exploitation of minors, or other illegal content on the Yaaro platform, please report it to us at <a href='mailto:customer@yaarolive.com'>customer@yaarolive.com</a>. Please provide sufficient information (such as the relevant username, content location, and a detailed description) to enable Yaaro to locate and address the material promptly.
      </p>

      <h2>Additional Resources</h2>
      <p>
        If you encounter cases of child exploitation or abuse elsewhere on the internet or in offline settings, we strongly encourage you to contact the relevant organizations listed below based on your location:
      </p>
      <ul>
        <li>
          <strong>North America, Australia, New Zealand:</strong>{' '}
          <a href='https://www.missingkids.org/gethelpnow/cybertipline' target='_blank' rel='noreferrer'>
            National Center for Missing &amp; Exploited Children (NCMEC)
          </a>
        </li>
        <li>
          <strong>Europe:</strong>{' '}
          <a href='https://www.europol.europa.eu/report-a-crime/law-enforcement-reporting-channels-child-sexual-coercion-and-extortion' target='_blank' rel='noreferrer'>
            Local law enforcement reporting channels for child sexual coercion and extortion.
          </a>
        </li>
        <li>
          <strong>South America and Other Regions:</strong>{' '}
          <a href='https://www.icmec.org/education-portal/reporting-mechanisms/' target='_blank' rel='noreferrer'>
            International Centre for Missing &amp; Exploited Children (ICMEC) global hotline
          </a>
          {' '}or your local child protection services.
        </li>
      </ul>
    </div>
  </Layout>
)

export default AboutCsap
